var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfant = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "infant",
  fillRule: "nonzero",
  fill: "#4A4A4A"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(13.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.894,0 C3.08805299,0.00551012476 0.00440615152,3.09005155 0,6.896 C0,10.178 2.306,12.931 5.383,13.623 C5.01874898,13.2740726 4.77380122,12.8191696 4.683,12.323 C2.47736538,11.4227996 1.03502968,9.27826377 1.033,6.896 C1.03507223,4.59665891 2.380334,2.51054534 4.474,1.56 C4.394,2.018 4.737,2.545 5.127,3.018 C5.481,3.445 5.329,3.768 5.057,3.994 C4.9719411,4.06512559 4.93992252,4.18155259 4.97665015,4.28617069 C5.01337778,4.39078879 5.11114716,4.46165193 5.222,4.464 C8.734,4.518 9.587,2.52 9.782,1.8 C11.6185059,2.83970942 12.754102,4.78660937 12.755,6.897 C12.7537253,9.14617322 11.4673814,11.1968665 9.443,12.177 C9.383,12.677 9.168,13.145 8.828,13.517 C11.695,12.68 13.796,10.03 13.796,6.897 C13.794,3.095 10.699,0 6.897,0 L6.894,0 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 4.776,
  cy: 6.776,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 8.776,
  cy: 6.776,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.491,11.14 C4.66856824,10.5891565 5.03843653,10.1206094 5.533,9.82 C5.573,9.185 6.093,8.68 6.73,8.68 C7.342,8.68 7.85,9.153 7.92,9.76 C8.46,10.053 8.874,10.55 9.064,11.147 C9.374,10.822 9.557,10.43 9.557,10.007 C9.557,8.897 8.313,8 6.78,8 C5.245,8 4,8.898 4,10.006 C4,10.424 4.18,10.812 4.485,11.134 L4.491,11.14 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25,11.027 C7.06912316,10.9669333 6.87330727,10.9693986 6.694,11.034 C6.774,11.056 6.754,11.059 6.674,11.041 C6.34218219,11.1673963 6.1231938,11.4859248 6.124,11.841 L6.127,11.884 C6.68596329,12.0148162 7.26742729,12.0161844 7.827,11.888 L7.827,11.84 C7.82650951,11.4733629 7.59178602,11.1480514 7.244,11.032 L7.25,11.027 Z M6.957,9.00000004 C6.524,9.00000004 6.153,9.26600004 6,9.64300004 C6.60249852,9.36852288 7.29214898,9.35765083 7.903,9.61300004 C7.73615537,9.23998204 7.3656313,8.99988558 6.957,9.00000004 L6.957,9.00000004 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.146,10.001 C5.96209932,10.0031994 5.00275122,10.9621005 5,12.146 C5.001651,13.3306806 5.96132032,14.2907971 7.146,14.293 C8.3307456,14.2913455 9.2904496,13.3307466 9.291,12.146 C9.291,10.962 8.331,10.002 7.146,10 L7.146,10.001 Z M7.146,13.257 C6.55880775,13.221735 6.10066333,12.7352503 6.10066333,12.147 C6.10066333,11.5587497 6.55880775,11.072265 7.146,11.037 C7.75903607,11.037 8.256,11.5339639 8.256,12.147 C8.256,12.7600361 7.75903607,13.257 7.146,13.257 L7.146,13.257 Z",
  id: "Shape"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfant);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/infant.2d7c47c9e62db285b723098e437fc91f.svg";